<template>
  <b-navbar type="light" class="navbar-light theme-nav fixed-top" toggleable="lg" fixed="top"
            v-b-scrollspy:nav-scroller>
    <div class="container">
      <b-navbar-toggle target="nav_collapse"></b-navbar-toggle>
      <b-navbar-brand class="navbar-brand" :to="{name:'Offer'}">
        <img height="45" src="../assets/images/tfLogo.png" alt="logo">
      </b-navbar-brand>
      <b-collapse class="default-nav" is-nav id="nav_collapse">
        <b-navbar-nav class="navbar-nav ml-auto" id="mainMenu">
          <b-nav-item :href='"/offer"' :to="{name:'Offer'}" :active="$route.name ==='Offer'" class="nav-link">
            {{ $t('navbar.offer') }}
          </b-nav-item>
          <b-nav-item :href='"/company"' :to="{name:'Company'}" :active="$route.name ==='Company'" class="nav-link">
            {{ $t('navbar.company') }}
          </b-nav-item>
          <b-nav-item :href='"/service"' :to="{name:'Service'}" :active="$route.name ==='Service'" class="nav-link">
            {{ $t('navbar.service') }}
          </b-nav-item>
          <b-nav-item :href='"/faq"' :to="{name:'Faq'}" :active="$route.name ==='Faq'" class="nav-link">
            {{ $t('navbar.faq') }}
          </b-nav-item>
            <a href="https://online.tf-ua.com/" role="button" class="btn btn-custom theme-color theme-color hiddenxs">{{ $t('navbar.enter') }}</a>
          <b-nav-item-dropdown right-alignment :text="GetName($i18n.locale)" href="#" class="nav-link ">
            <b-dropdown-item class="nav-link " @click="SetLocale(locale)"
                             v-for="locale in $i18n.availableLocales" :key="`locale-${locale}`" :value="locale">
              {{GetName(locale) }}
            </b-dropdown-item>
          </b-nav-item-dropdown>
          <a href="https://online.tf-ua.com/" role="button" class="btn btn-custom theme-color theme-color visiblexs">{{ $t('navbar.enter') }}</a>
        </b-navbar-nav>
      </b-collapse>
    </div>
  </b-navbar>
</template>
<script>
  import {defineComponent} from 'vue'
  import {useI18n} from 'vue-i18n-composable'

  export default defineComponent({
    name: 'Navbar',
    setup () {
      return {
        ...useI18n()
      }
    },
    methods: {
      GetName (localname) {
        if (localname == 'uk') {
          return 'ua'
        } else {
          return localname
        }
      },
      SetLocale (locale) {
        console.log(locale)
        this.$i18n.locale = locale
        localStorage.setItem('lang', locale)
      },
    },
  })
</script>

<style scoped>
    @media only screen and (max-width: 991px) {
    .hiddenxs {
      display: none !important;
    }
    .visiblexs{
      display:inherit;
    }
  }
  @media only screen and (min-width: 991px) {
    .visiblexs{
      display: none !important;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/navbar.vue